import { Helmet } from "react-helmet-async";
import Screen from "../../Layouts/Screen/Screen";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../global-components/src";
import ItemList from "../../../components/ItemList/ItemList";
import feather from "feather-icons";
import "./style.css"
import Spinner from "../../../global-components/src/components/spinner/spiner";
import { useMessage } from "../../../global-components/src";
import { PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import { Stamp, User } from "../../../global-components/src/types";
import { useTranslation } from 'react-i18next';

type PhoneChatDetails = {
    registered: boolean;
    number: string | null;
    verified_at: string | null;
};

const PermissionsScreen = () => {
    const { id: userId } = useParams();
    const [user, setUser ] = useState<User>();
    const [permissions, setPermissions] = useState<any[]>([]);
    const [stamps, setStamps] = useState<Stamp[]>([]);
    const { token, user: authUser, isSuper } = useAuth();
    const [loading, setLoading] = useState(true);
    const [loadingData, setLoadingData] = useState(false); 
    const [error, setError] = useState("");
    const [errorsInput, setErrorsInput] = useState<{ login?: string[]; password?: string[]; manual_phone?: string[]; phone_verified?: string[] }>({});
    const [updatedPermissions, setUpdatedPermissions] = useState<string[]>([]);
    const [emailValidatedAt, setEmailValidatedAt] = useState<any>();
    const [giveSelos, setGiveSelos] = useState<boolean>(false);
    const [editPermissions, setEditPermissions] = useState<boolean>(false);
    const [validadeEmail, setValidadeEmail] = useState<boolean>(false);
    const [validatePhone, setValidatePhone] = useState<boolean>(false);
    const [phoneChat, setPhoneChat] = useState<PhoneChatDetails | null>(null);
    const [phoneVerified, setPhoneVerified] = useState<boolean>(false);
    const [initialPhoneVerified, setInitialPhoneVerified] = useState<boolean>(false);
    const [manualPhone, setManualPhone] = useState("");
    const [position, setPosition] = useState<number | null>(null);
    const [profileVerifiedBy, setProfileVerifiedBy] = useState<any | null>(null);
    const [errorLoaded, setErrorLoaded] = useState<boolean>(false);
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const alterPosition = (newPosition: number) => {
        if (position === newPosition){
            setPosition(null)
            setUpdatedPermissions([]);
        }
        else{
            setPosition(newPosition)
            updatedPermissions.push("block_user")
            updatedPermissions.push("delete_post")
            updatedPermissions.push("delete_comment")
            updatedPermissions.push("send_warn")
            updatedPermissions.push("remove_photo_profile")
            updatedPermissions.push("delete_community")
            updatedPermissions.push("validate_email")
            
        }
    }

    useEffect(() => {
        if ((window as any).lucide) {
        (window as any).lucide.createIcons();
        }
    }, [permissions]);

    const handlePermissionChange = (event: React.ChangeEvent<HTMLInputElement>, permission: string) => {
        const isChecked = event.target.checked;

        setUpdatedPermissions((prevPermissions) => {
            return isChecked
                ? [...prevPermissions, permission] // Adiciona se marcado
                : prevPermissions.filter((p) => p !== permission); // Remove se desmarcado
        });
    };

    useEffect(() => {
        feather.replace();
    }, [permissions]); // Chama sempre que as permissões forem carregadas

    const handleAlterPermission = async () => {
        setLoadingData(true)
        try {
            await axios.post(`${PACOCA_API_URL}/users/permissions/${userId}`, {
                position, permissions: updatedPermissions, email_verified_at: emailValidatedAt, verified_profile: stamps.includes("blue"), profile_verified_by: profileVerifiedBy, stamps,
                ...(validatePhone && (phoneVerified !== initialPhoneVerified || manualPhone.trim()) ? {
                    phone_verified: phoneVerified,
                    ...(!phoneChat?.registered && manualPhone.trim() ? { manual_phone: manualPhone.trim() } : {}),
                } : {}),
            }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            setMessage("Informações atualizadas", "success")
            setLoadingData(false);
            navigate(`/@${user?.user_name}`);
        } catch (err: any) {
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os err, "error"os
                const phoneError = err.response.data.errors.manual_phone?.[0] || err.response.data.errors.phone_verified?.[0];
                if (phoneError) setMessage(phoneError, "error");
            } else {
                if (err.status == 429 && err.message.blocked)
                    setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

                if (err.status == 429)
                    setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

                if (err.response) {
                    // O servidor respondeu com um código de erro
                    console.error("Erro no servidor:", err.response.status, err.response.data);
                    setMessage(err.response.data.message || "Erro atualizar!", "error");
                } else if (err.request) {
                    // A requisição foi feita, mas não houve resposta
                    console.error("Nenhuma resposta do servidor:", err.request);
                    setMessage(t("generics.errors.genericServerError"), "error");
                } else {
                    // Outro tipo de erro (ex: erro de configuração)
                    console.error("Erro inesperado:", err.message);
                    setMessage("Ocorreu um erro inesperado!", "error");
                }
            }
            setLoadingData(false)
            console.error(err);
        }
        finally {
            setLoadingData(false)
        }
    }

    const loadDadaEdit = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${PACOCA_API_URL}/users/find/${userId}`, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response?.data;

            if (data) {
                setUser(data.user)
                setPermissions(data.permissions)
                setUpdatedPermissions(data.user.permissions || [])
                setGiveSelos(data.giveSelos)
                setEditPermissions(data.editPermissions)
                setValidadeEmail(data.validateEmail)
                setValidatePhone(Boolean(data.validatePhone))
                setPhoneChat(data.phoneChat ?? null)
                const phoneIsVerified = Boolean(data.phoneChat?.verified_at)
                setPhoneVerified(phoneIsVerified)
                setInitialPhoneVerified(phoneIsVerified)
                setManualPhone("")
                setPosition(data.user.position)
                setStamps(data.user.stamps ?? []);
                setEmailValidatedAt(data.user.email_verified_at ? new Date(data.user.email_verified_at).toISOString().split("T")[0] : "");
                setProfileVerifiedBy(data.user.next_payment ? new Date(data.user.next_payment).toISOString().split("T")[0] : "")
            }
        } catch (err: any) {
            setErrorLoaded(true);
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os err, "error"os
            } else {
                if (err.status == 429 && err.message.blocked)
                    setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

                if (err.status == 429)
                    setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

                if (err.response) {
                    // O servidor respondeu com um código de erro
                    console.error("Erro no servidor:", err.response.status, err.response.data);
                    setMessage(err.response.data.message || "Erro atualizar!", "error");
                } else if (err.request) {
                    // A requisição foi feita, mas não houve resposta
                    console.error("Nenhuma resposta do servidor:", err.request);
                    setMessage(t("generics.errors.genericServerError"), "error");
                } else {
                    // Outro tipo de erro (ex: erro de configuração)
                    console.error("Erro inesperado:", err.message);
                    setMessage("Ocorreu um erro inesperado!", "error");
                }
            }
            console.error(err);
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadDadaEdit()
    }, []);

    const toggleStamp = (stamp: Stamp) => {
        setStamps((prev) => {
            // Se já existe, apenas remove
            if (prev.includes(stamp)) {
                return prev.filter((s) => s !== stamp);
            }

            // Se estiver adicionando "black", remove "blue"
            if (stamp === 'black') {
                return [...prev.filter((s) => s !== 'blue'), 'black'];
            }

            // (Opcional) Se adicionar "blue", remove "black"
            if (stamp === 'blue') {
                return [...prev.filter((s) => s !== 'black'), 'blue'];
            }

            // Caso normal
            return [...prev, stamp];
        });
    };
    const hasStamp = (stamp: Stamp) => stamps.includes(stamp);

    return (
        <>
            <Screen paddingTopTitle title={errorLoaded ? "Erro" : `${t("permissions.title")} ${user?.name || ""}`}>
                <Helmet>
                    <title>Paçoca - {t("permissions.title")}</title>
                </Helmet>



                {!loading ? (
                    <>
                        {!errorLoaded ? (
                            <>
                                <h5 style={{ marginLeft: 10 }}>
                                    <Link to={`/@${user?.user_name}`}>@{user?.user_name}</Link>
                                </h5>

                                {/* permissoes  */}
                                {editPermissions ? (
                                    <>
                                        {permissions && typeof permissions === "object" && Object.keys(permissions).length > 0 ? (
                                            Object.entries(permissions).map(([key, value]: [string, any]) => (
                                                <ItemList key={key}>
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            name="permissions[]"
                                                            type="checkbox"
                                                            id={key}
                                                            value={key}
                                                            checked={updatedPermissions && updatedPermissions.includes(key)}
                                                            onChange={(e) => handlePermissionChange(e, key)}
                                                        />
                                                        <label className="cursor-pointer form-check-label" style={{ margin: 0 }} htmlFor={key}>
                                                            <i data-lucide={value?.icon || "alert-circle"} className="icon-permissions"></i>
                                                            {value?.label || key}
                                                        </label>
                                                    </div>
                                                </ItemList>
                                            ))
                                        ) : null}

                                    </>
                                ) : null}


                                {validadeEmail ? (
                                    <ItemList>
                                        <label className="form-check-label d-flex align-items-center" htmlFor="email_verified_at" style={{ gap: "10px", margin: 0 }}>
                                            Email Validado:
                                        </label>
                                        <input onChange={(e) => setEmailValidatedAt(e.target.value)} className="w-100 form-control" name="email_verified_at" type="date" id="email_verified_at"
                                            value={emailValidatedAt} />
                                    </ItemList>
                                ) : null}

                                {validatePhone ? (
                                    <>
                                        <h5 className="mt-4" style={{ marginLeft: 10 }}>Paçoca Papo</h5>
                                        <ItemList>
                                            <div className="phone-chat-permissions">
                                                {phoneChat?.registered ? (
                                                    <p className="phone-chat-permissions-status">
                                                        Número cadastrado: <strong>{phoneChat.number}</strong>
                                                        <br />
                                                        Status: {phoneChat.verified_at ? "validado" : "pendente de validação"}.
                                                    </p>
                                                ) : (
                                                    <>
                                                        <p className="phone-chat-permissions-status">
                                                            Nenhum telefone do Paçoca Papo está associado a esta conta.
                                                        </p>
                                                        <label className="form-check-label" htmlFor="manual_phone">
                                                            Número cadastrado no Firebase
                                                        </label>
                                                        <input
                                                            className={`w-100 form-control mt-2 ${errorsInput.manual_phone ? 'is-invalid' : ''}`}
                                                            id="manual_phone"
                                                            name="manual_phone"
                                                            type="tel"
                                                            inputMode="tel"
                                                            autoComplete="off"
                                                            placeholder="+5511999999999"
                                                            value={manualPhone}
                                                            onChange={(e) => {
                                                                setManualPhone(e.target.value)
                                                                setErrorsInput((prev) => ({ ...prev, manual_phone: undefined, phone_verified: undefined }))
                                                            }}
                                                        />
                                                        {errorsInput.manual_phone ? (
                                                            <div className="invalid-feedback">{errorsInput.manual_phone[0]}</div>
                                                        ) : null}
                                                        <small className="phone-chat-permissions-help">
                                                            Informe o número em formato internacional somente depois de confirmá-lo manualmente no Firebase.
                                                        </small>
                                                    </>
                                                )}

                                                <div className="form-check form-switch mt-3">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="phone_verified"
                                                        checked={phoneVerified}
                                                        disabled={!phoneChat?.registered && !manualPhone.trim()}
                                                        onChange={(e) => setPhoneVerified(e.target.checked)}
                                                    />
                                                    <label className="cursor-pointer form-check-label" htmlFor="phone_verified">
                                                        Validar telefone manualmente
                                                    </label>
                                                </div>
                                            </div>
                                        </ItemList>
                                    </>
                                ) : null}

                                <h5 className="mt-4" style={{ marginLeft: 10 }}>Selos</h5>
                                <ItemList>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="stamp-autism" checked={hasStamp("autism")} onChange={() => toggleStamp("autism")}/>
                                        <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-autism" style={{ gap: "10px", margin: 0 }}>
                                        <img height="17" src="/img/selos/autism.png" loading="lazy" />
                                            {t("meaningSeals.autism.title")}
                                        </label>
                                    </div>
                                </ItemList>
                                <ItemList>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="stamp-lgbt" checked={hasStamp("lgbt")} onChange={() => toggleStamp("lgbt")}/>
                                        <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-lgbt" style={{ gap: "10px", margin: 0 }}>
                                        <img height="17" src="/img/selos/lgbt.png" loading="lazy" />
                                            {t("meaningSeals.lgbt.title")}
                                        </label>
                                    </div>
                                </ItemList>
                                <ItemList>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" id="stamp-hidden-deficiencies" checked={hasStamp("hidden_deficiencies")} onChange={() => toggleStamp("hidden_deficiencies")}/>
                                        <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-hidden-deficiencies" style={{ gap: "10px", margin: 0 }}>
                                        <img height="17" src="/img/selos/hidden_deficiencies.png" loading="lazy" />
                                            {t("meaningSeals.hidden_deficiencies.title")}
                                        </label>
                                    </div>
                                </ItemList>

                                {giveSelos ? (
                                    <>
                                        <ItemList>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id="stamp-black" checked={hasStamp("black")} onChange={() => toggleStamp("black")} />
                                                <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-black" style={{ gap: "10px", margin: 0 }} >
                                                <img className="img-vefified-company-color" height="17" src="/img/selos/black.png" loading="lazy" />
                                                    {t("meaningSeals.black.title")}
                                                </label>
                                            </div>

                                            {hasStamp("black") ? (
                                                <div className="w-100" style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}>
                                                    <div>
                                                        <label className="form-check-label d-flex align-items-center" htmlFor="verificado_date" style={{ gap: "10px" }}>
                                                            Até:
                                                        </label>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <input className="form-control" name="verificado_date" type="date" id="verificado_date" value={profileVerifiedBy} onChange={(e) => setProfileVerifiedBy(e.target.value)}></input>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </ItemList>

                                        <ItemList>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id="stamp-gray" checked={hasStamp("gray")} onChange={() => toggleStamp("gray")} />
                                                <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-gray" style={{ gap: "10px", margin: 0 }} >
                                                <img height="17" src="/img/selos/gray.png" loading="lazy" />
                                                    {t("meaningSeals.gray.title")}
                                                </label>
                                            </div>
                                        </ItemList>

                                        <ItemList>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id="stamp-purple" checked={hasStamp("purple")} onChange={() => toggleStamp("purple")} />
                                                <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-purple" style={{ gap: "10px", margin: 0 }} >
                                                <img height="17" src="/img/selos/purple.png" loading="lazy" />
                                                    {t("meaningSeals.purple.title")}
                                                </label>
                                            </div>
                                        </ItemList>

                                        <ItemList>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id="stamp-yellow" checked={hasStamp("yellow")} onChange={() => toggleStamp("yellow")} />
                                                <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-yellow" style={{ gap: "10px", margin: 0 }} >
                                                <img height="17" src="/img/selos/yellow.png" loading="lazy" />
                                                    {t("meaningSeals.yellow.title")}
                                                </label>
                                            </div>
                                        </ItemList>

                                        {authUser &&  (isSuper() || (authUser.position&& authUser.position !=0 && authUser.position < 1)) ? (
                                            <ItemList>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        name="position"
                                                        type="checkbox"
                                                        id="owner"
                                                        value="1"
                                                        onChange={() => alterPosition(1)}
                                                        checked={position === 1}
                                                    />
                                                    <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="owner" style={{ gap: "10px", margin: 0 }}>
                                                        <img height="17" alt="Imagem de verificado" src="/img/selos/brown.png" loading="lazy" />
                                                        {t("meaningSeals.brown.title")}
                                                    </label>
                                                </div>
                                            </ItemList>
                                        ) : null}
                                        
                                        {authUser &&  (isSuper() || (authUser.position&& authUser.position !=0 && authUser.position < 2)) ? (
                                            <ItemList>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        name="position"
                                                        type="checkbox"
                                                        id="coordinator"
                                                        value="2"
                                                        onChange={() => alterPosition(2)}
                                                        checked={position === 2}
                                                    />
                                                    <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="coordinator" style={{ gap: "10px", margin: 0 }}>
                                                        <img height="17" alt="Imagem de verificado" src="/img/selos/darkBlue.png" loading="lazy" />
                                                        {t("meaningSeals.darkBlue.title")}
                                                    </label>
                                                </div>
                                            </ItemList>
                                        ) : null}

                                        {authUser &&  (isSuper() || (authUser.position&& authUser.position !=0 && authUser.position < 3)) ? (
                                            <ItemList>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        name="position"
                                                        type="checkbox"
                                                        id="moderator"
                                                        value="2"
                                                        onChange={() => alterPosition(3)}
                                                        checked={position === 3}
                                                    />
                                                    <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="moderator" style={{ gap: "10px", margin: 0 }}>
                                                        <img height="17" alt="Imagem de verificado" src="/img/selos/red.png" loading="lazy" />
                                                        {t("meaningSeals.red.title")}
                                                    </label>
                                                </div>
                                            </ItemList>
                                        ) : null}

                                        {authUser &&  (isSuper() || (authUser.position&& authUser.position !=0 && authUser.position < 4)) ? (
                                            <ItemList>
                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        name="position"
                                                        type="checkbox"
                                                        id="helper"
                                                        value="2" 
                                                        onChange={() => alterPosition(4)}
                                                        checked={position === 4}
                                                    />
                                                    <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="helper" style={{ gap: "10px", margin: 0 }}>
                                                        <img height="17" alt="Imagem de verificado" src="/img/selos/peach.png" loading="lazy" />
                                                        {t("meaningSeals.peach.title")}
                                                    </label>
                                                </div>
                                            </ItemList>
                                        ) : null}

                                    {isSuper() && (
                                        <ItemList>
                                            <div className="form-check form-switch">
                                                <input className="form-check-input" type="checkbox" id="stamp-blue" checked={hasStamp("blue")} onChange={() => toggleStamp("blue")}/>
                                                <label className="cursor-pointer form-check-label d-flex align-items-center" htmlFor="stamp-blue" style={{ gap: "10px", margin: 0 }}>
                                                <img height="17" src="/img/selos/verified.png" loading="lazy" />
                                                    Verificado
                                                </label>
                                            </div>

                                            {hasStamp("blue") ? (
                                                <div className="w-100" style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}>
                                                    <div>
                                                        <label className="form-check-label d-flex align-items-center" htmlFor="verificado_date" style={{ gap: "10px" }}>
                                                            Até:
                                                        </label>
                                                    </div>
                                                    <div style={{ flex: "1" }}>
                                                        <input className="form-control" name="verificado_date" type="date" id="verificado_date" value={profileVerifiedBy} onChange={(e) => setProfileVerifiedBy(e.target.value)}></input>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </ItemList>
                                    )}
                                    </>
                                ) : null}

                                <ItemList>
                                    <button disabled={loadingData} className="btn-w-100 btn btn-blue w-100 mt-4" onClick={handleAlterPermission}>
                                        {loadingData ? (
                                            <Spinner size="20px" />
                                        ) : (
                                            <div>
                                                Salvar
                                            </div>
                                        )}
                                    </button>
                                </ItemList>
                            </>
                        ) : null}
                    </>

                ) : (
                    <div className="">
                        {[...Array(10)].map((_, index) => (
                            <div key={index} style={{ height: 40, width: "100%" }} className="mt-2 placeholder"></div>
                        ))}
                    </div>
                )}

            </Screen>
        </>
    );
};

export default PermissionsScreen;